export default {
    fire_edge: {
        name: "Fire Edge",
        url: "nwcg_lines_fire/fire_edge",
    },
    uncontained: {
        name: "Uncontained",
        url: "nwcg_lines_fire/uncontained",
    },
}
